import React from 'react';
import styles from './manager-mini-card.module.scss';
import { ICardManagerInfo } from './manager-mini-card.interface';
import { useNavigate } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { CircleImage } from '../circle-image/circle-image';

export interface IManagerMiniCardProps {
  managerInfo: ICardManagerInfo;
}

export const ManagerMiniCard: React.FC<IManagerMiniCardProps> = ({
  managerInfo,
}) => {
  const navigate = useNavigate();

  const handleNavigateClick = () => {
    const path = AppLinks.ManagerLink.replace(':id', String(managerInfo.id));
    navigate(path);
  };
  return (
    <div
      className={styles.manager_card__container}
      onClick={handleNavigateClick}
    >
      <div className={styles.manager__title}>
        <CircleImage imgSize={35} imgSrc={managerInfo.imgUrl} />
        <div className={styles.title__name}>{managerInfo.fio}</div>
      </div>
    </div>
  );
};
